var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-layout",
    { ref: "layout", attrs: { view: "lHh Lpr fff" } },
    [
      _c(
        "q-layout-header",
        [
          _c(
            "q-toolbar",
            {
              staticStyle: {
                height: "45px",
                "background-color": "#093370 !important"
              }
            },
            [
              _c("q-btn", {
                attrs: { flat: "", round: "", small: "", icon: "fas fa-bars" },
                on: {
                  click: function($event) {
                    _vm.miniStateBarra = !_vm.miniStateBarra
                  }
                }
              }),
              _c("img", {
                staticStyle: {
                  width: "50px",
                  padding: "3px",
                  "margin-left": "15px",
                  "margin-right": "-5px"
                },
                attrs: { src: "/statics/icons/icone-branco.png" }
              }),
              _c("q-toolbar-title", [
                _c("strong", { staticClass: "toolbar-title" }, [
                  _vm._v("Protocolo")
                ]),
                _c(
                  "p",
                  {
                    staticClass: "q-ma-none",
                    staticStyle: { "font-size": "15px" }
                  },
                  [_vm._v(_vm._s(_vm.getNomeCliente()))]
                )
              ]),
              _vm.setQtdeNotificacao() !== 0
                ? _c(
                    "q-chip",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.mostrarNotificacoes,
                          expression: "mostrarNotificacoes"
                        }
                      ],
                      attrs: {
                        dense: "",
                        color: "red-5",
                        "text-color": "white"
                      }
                    },
                    [_vm._v(_vm._s(_vm.setQtdeNotificacao()))]
                  )
                : _vm._e(),
              _c(
                "q-btn-dropdown",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.mostrarNotificacoes,
                      expression: "mostrarNotificacoes"
                    }
                  ],
                  staticStyle: { "-webkit-box-shadow": "0 0 0 0" },
                  attrs: {
                    color: "primary",
                    icon: "mail",
                    dense: "",
                    small: ""
                  }
                },
                [
                  _c(
                    "q-list",
                    { attrs: { link: "", separator: "" } },
                    [
                      _vm._l(_vm.arrayNotificacao, function(n) {
                        return _c(
                          "q-item",
                          {
                            key: n.a,
                            nativeOn: {
                              click: function($event) {
                                _vm.responderSolicitacao(
                                  n.protocoloSolicitacao.id,
                                  n.codNotificacaoSolicitacao
                                )
                              }
                            }
                          },
                          [
                            _c(
                              "q-item-main",
                              { staticStyle: { width: "100%" } },
                              [
                                n.indAtiva === "N"
                                  ? _c(
                                      "q-item-tile",
                                      { attrs: { label: "" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.setDataNotificacao(
                                              n.datNotificacao
                                            )
                                          ) +
                                            " Solicitação Nº: " +
                                            _vm._s(
                                              n.protocoloSolicitacao
                                                .numSolicitacao
                                            )
                                        )
                                      ]
                                    )
                                  : _c(
                                      "q-item-tile",
                                      { attrs: { label: "" } },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.setDataNotificacao(
                                                n.datNotificacao
                                              )
                                            ) +
                                              " Solicitação Nº: " +
                                              _vm._s(
                                                n.protocoloSolicitacao
                                                  .numSolicitacao
                                              )
                                          )
                                        ])
                                      ]
                                    ),
                                n.indAtiva === "N"
                                  ? _c(
                                      "q-item-tile",
                                      { attrs: { sublabel: "" } },
                                      [
                                        _vm._v("Assunto: "),
                                        n.protocoloSolicitacao.subassunto
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  n.protocoloSolicitacao
                                                    .subassunto.assunto
                                                    .desAssunto
                                                )
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    )
                                  : _c(
                                      "q-item-tile",
                                      { attrs: { sublabel: "" } },
                                      [
                                        _c("strong", [
                                          _vm._v("Assunto: "),
                                          n.protocoloSolicitacao.subassunto
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    n.protocoloSolicitacao
                                                      .subassunto.assunto
                                                      .desAssunto
                                                  )
                                                )
                                              ])
                                            : _vm._e()
                                        ])
                                      ]
                                    ),
                                n.indAtiva === "N"
                                  ? _c(
                                      "q-item-tile",
                                      { attrs: { sublabel: "" } },
                                      [
                                        _vm._v("SubAssunto: "),
                                        n.protocoloSolicitacao.subassunto
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  n.protocoloSolicitacao
                                                    .subassunto.desSubassunto
                                                )
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    )
                                  : _c(
                                      "q-item-tile",
                                      { attrs: { sublabel: "" } },
                                      [
                                        _c("strong", [
                                          _vm._v("SubAssunto: "),
                                          n.protocoloSolicitacao.subassunto
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    n.protocoloSolicitacao
                                                      .subassunto.desSubassunto
                                                  )
                                                )
                                              ])
                                            : _vm._e()
                                        ])
                                      ]
                                    ),
                                n.indAtiva === "N"
                                  ? _c(
                                      "q-item-tile",
                                      { attrs: { sublabel: "" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            n.protocoloSolicitacao.requerente
                                              .nomeDocumento
                                          )
                                        )
                                      ]
                                    )
                                  : _c(
                                      "q-item-tile",
                                      { attrs: { sublabel: "" } },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              n.protocoloSolicitacao.requerente
                                                .nomeDocumento
                                            )
                                          )
                                        ])
                                      ]
                                    ),
                                n.indAtiva === "N"
                                  ? _c(
                                      "q-item-tile",
                                      { attrs: { sublabel: "" } },
                                      [_vm._v(_vm._s(n.desMensagem))]
                                    )
                                  : _c(
                                      "q-item-tile",
                                      { attrs: { sublabel: "" } },
                                      [
                                        _c("strong", [
                                          _vm._v(_vm._s(n.desMensagem))
                                        ])
                                      ]
                                    )
                              ],
                              1
                            ),
                            _c("q-item-side", {
                              attrs: {
                                right: "",
                                dense: "",
                                icon: "fas fa-external-link-alt",
                                color: "blue"
                              }
                            })
                          ],
                          1
                        )
                      }),
                      _vm.arrayNotificacao.length === 0
                        ? _c(
                            "q-item",
                            [
                              _c("q-item-side", {
                                attrs: {
                                  right: "",
                                  dense: "",
                                  icon: "far fa-smile-beam",
                                  color: "blue-6"
                                }
                              }),
                              _c(
                                "q-item-main",
                                { staticStyle: { width: "100%" } },
                                [
                                  _c("q-item-tile", { attrs: { label: "" } }, [
                                    _vm._v(" Nenhuma Notificação Web ")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              ),
              _c(
                "q-item",
                { staticClass: "item-usuario" },
                [
                  _c(
                    "div",
                    [
                      _c("q-item-main", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$login.getNomUsuario()) +
                            "\n            "
                        ),
                        _c("p", { staticClass: "adm-ano" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.administracaoCorrenteNome) +
                              "\n              "
                          )
                        ])
                      ])
                    ],
                    1
                  ),
                  _c(
                    "q-popover",
                    {
                      ref: "refPopover",
                      staticClass: "shadow-2",
                      staticStyle: {
                        background: "#093370",
                        "border-radius": "0%"
                      },
                      attrs: {
                        anchor: "bottom right",
                        self: "top right",
                        fit: true,
                        offset: [100, -11],
                        id: "popover"
                      }
                    },
                    [
                      _c(
                        "div",
                        { on: { mouseenter: _vm.abrirPopover } },
                        [
                          _c(
                            "q-list",
                            {
                              staticClass: "q-pa-none lista-dropdown-popup",
                              staticStyle: { width: "200px" },
                              attrs: { link: "" }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "span-aux",
                                  on: { click: _vm.abrirModal }
                                },
                                [
                                  _c(
                                    "q-item",
                                    {
                                      staticClass:
                                        "item-lista-dropdown shadow-2"
                                    },
                                    [
                                      _c(
                                        "q-item-main",
                                        [
                                          _c("q-btn", {
                                            attrs: {
                                              small: "",
                                              round: "",
                                              flat: "",
                                              icon: "fa fa-exchange-alt",
                                              disable: _vm.appCarregando
                                            },
                                            on: { click: _vm.abrirModal }
                                          }),
                                          _c("span", [
                                            _vm._v("Administração/Ano")
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "span-aux",
                                  on: {
                                    click: function(val) {
                                      return _vm.home()
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "q-item",
                                    {
                                      staticClass:
                                        "item-lista-dropdown shadow-2"
                                    },
                                    [
                                      _c(
                                        "q-item-main",
                                        [
                                          _c("q-btn", {
                                            attrs: {
                                              round: "",
                                              flat: "",
                                              icon: "fa fa-home",
                                              small: "",
                                              disable: _vm.appCarregando
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.home()
                                              }
                                            }
                                          }),
                                          _c("span", [_vm._v("Home")])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "span-aux",
                                  on: { click: _vm.abrirCadUnico }
                                },
                                [
                                  _c(
                                    "q-item",
                                    {
                                      staticClass:
                                        "item-lista-dropdown shadow-2"
                                    },
                                    [
                                      _c(
                                        "q-item-main",
                                        [
                                          _c("q-btn", {
                                            attrs: {
                                              small: "",
                                              round: "",
                                              flat: "",
                                              icon: "fa fa-cogs",
                                              disable: _vm.appCarregando
                                            },
                                            on: { click: _vm.abrirCadUnico }
                                          }),
                                          _c("span", [_vm._v("Sistemas")])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "span-aux",
                                  on: {
                                    click: function(val) {
                                      return _vm.logout()
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "q-item",
                                    {
                                      staticClass:
                                        "item-lista-dropdown shadow-2"
                                    },
                                    [
                                      _c(
                                        "q-item-main",
                                        [
                                          _c("q-btn", {
                                            attrs: {
                                              round: "",
                                              flat: "",
                                              icon: "fa fa-sign-out-alt",
                                              small: "",
                                              disable: _vm.appCarregando
                                            },
                                            on: {
                                              click: function($event) {
                                                _vm.logout()
                                              }
                                            }
                                          }),
                                          _c("span", [_vm._v("Sair")])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-layout-drawer",
        {
          attrs: {
            mini: _vm.miniStateBarra && _vm.miniState,
            side: "left",
            overlay: false,
            "content-class": "sidebar"
          },
          on: {
            mouseover: function($event) {
              _vm.miniState = false
            },
            mouseout: function($event) {
              _vm.miniState = true
            }
          },
          model: {
            value: _vm.showLeft,
            callback: function($$v) {
              _vm.showLeft = $$v
            },
            expression: "showLeft"
          }
        },
        [
          _c(
            "div",
            { staticClass: "left-menu", staticStyle: { height: "100%" } },
            [
              _c(
                "q-scroll-area",
                {
                  staticClass: "fit",
                  staticStyle: { height: "100%" },
                  attrs: {
                    "thumb-style": {
                      right: "0",
                      borderRadius: "20px",
                      width: "10px",
                      height: "20px",
                      opacity: 0.4
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      class:
                        "text-center" + " fixed-bottom-rodape shadow-up-10",
                      staticStyle: { background: "rgb(9, 51, 112) !important" }
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "http://publicenter.com.br",
                            target: "_blank"
                          }
                        },
                        [
                          _vm.miniState && _vm.miniStateBarra
                            ? _c("img", {
                                staticClass: "user-card-imageRodape",
                                staticStyle: {
                                  height: "35px!important",
                                  width: "auto"
                                },
                                attrs: {
                                  src:
                                    "statics/" +
                                    _vm.logoEmpresa +
                                    "LogoTipo.png",
                                  alt: "publicenter.com.br"
                                }
                              })
                            : _c("img", {
                                staticStyle: {
                                  height: "42px",
                                  width: "auto",
                                  margin: "2px 2px -8px 7px"
                                },
                                attrs: {
                                  src:
                                    "statics/" +
                                    _vm.logoEmpresa +
                                    "LogoMarca.png",
                                  alt: "publicenter.com.br"
                                }
                              })
                        ]
                      ),
                      _c(
                        "p",
                        {
                          staticClass: "versao",
                          on: { click: _vm.redirecionarTelaVersoes }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.versao) +
                              "\n            "
                          ),
                          _c(
                            "q-tooltip",
                            {
                              attrs: {
                                anchor: "top middle",
                                self: "bottom middle",
                                offset: [10, 10]
                              }
                            },
                            [_c("strong", [_vm._v("Histórico de versões")])]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "q-item",
                    {
                      directives: [{ name: "ripple", rawName: "v-ripple" }],
                      staticClass: "shadow-2"
                    },
                    [
                      _c("q-icon", {
                        staticClass: "icone-sidebar",
                        attrs: {
                          name: "fas fa-search",
                          for: "pesquisaMenu",
                          size: "18px"
                        }
                      }),
                      _c(
                        "q-item-main",
                        [
                          _c("q-input", {
                            staticClass: "q-ml-md",
                            attrs: {
                              placeholder: "Pesquisa de menus",
                              id: "pesquisaMenu",
                              name: "pesquisaMenu",
                              color: "white"
                            },
                            on: { input: _vm.filtrarMenus },
                            model: {
                              value: _vm.termoPesquisa,
                              callback: function($$v) {
                                _vm.termoPesquisa = $$v
                              },
                              expression: "termoPesquisa"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._l(_vm.permissoesArrayPai, function(n0) {
                    return _c(
                      "div",
                      { key: n0.p },
                      [
                        _vm.verificarLink(n0.desPaginaPrincipal)
                          ? _c(
                              "q-item",
                              {
                                attrs: {
                                  to: n0.desPaginaPrincipal,
                                  icon: n0.desIconeModulo
                                }
                              },
                              [
                                _c("q-icon", {
                                  staticClass: "icone-sidebar",
                                  attrs: {
                                    name: n0.desIconeModulo,
                                    size: "20px"
                                  }
                                }),
                                _c("q-item-main", {
                                  staticClass: "q-pl-md",
                                  staticStyle: { color: "white" },
                                  attrs: {
                                    color: "white",
                                    label: n0.nomModulo,
                                    id: n0.nomModulo.replace(/\s{1,}/g, ""),
                                    name: n0.nomModulo.replace(/\s{1,}/g, "")
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        !_vm.verificarLink(n0.desPaginaPrincipal)
                          ? _c(
                              "q-collapsible",
                              {
                                ref: "ref" + n0.codModulo,
                                refInFor: true,
                                staticClass: "gvn-collapse shadow-2",
                                attrs: {
                                  group: "grupo1",
                                  label: n0.nomModulo,
                                  disable: _vm.appCarregando
                                }
                              },
                              [
                                _c(
                                  "template",
                                  { slot: "header" },
                                  [
                                    _c("q-icon", {
                                      staticClass: "icone-sidebar",
                                      attrs: {
                                        name: n0.desIconeModulo,
                                        size: "20px"
                                      }
                                    }),
                                    _c("q-item-main", {
                                      staticClass: "q-pl-md",
                                      attrs: {
                                        label: n0.nomModulo,
                                        id: n0.nomModulo.replace(/\s{1,}/g, ""),
                                        name: n0.nomModulo.replace(
                                          /\s{1,}/g,
                                          ""
                                        )
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._l(
                                  _vm.permissoesArray.filter(function(v) {
                                    return v.codModuloPai === n0.codModulo
                                  }),
                                  function(n1) {
                                    return _c("div", { key: n1.f }, [
                                      _c(
                                        "div",
                                        { staticClass: "q-pl-xl" },
                                        [
                                          _vm.verificarLink(
                                            n1.desPaginaPrincipal
                                          )
                                            ? _c(
                                                "q-item",
                                                {
                                                  attrs: {
                                                    to: n1.desPaginaPrincipal
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "template",
                                                    { slot: "header" },
                                                    [
                                                      _c("q-item-main", {
                                                        attrs: {
                                                          label: n1.nomModulo,
                                                          id: n1.nomModulo.replace(
                                                            /\s{1,}/g,
                                                            ""
                                                          ),
                                                          name: n1.nomModulo.replace(
                                                            /\s{1,}/g,
                                                            ""
                                                          )
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c("q-item-main", {
                                                    attrs: {
                                                      color: "white",
                                                      label: n1.nomModulo,
                                                      id: n1.nomModulo.replace(
                                                        /\s{1,}/g,
                                                        ""
                                                      ),
                                                      name: n1.nomModulo.replace(
                                                        /\s{1,}/g,
                                                        ""
                                                      )
                                                    }
                                                  })
                                                ],
                                                2
                                              )
                                            : _vm._e(),
                                          !_vm.verificarLink(
                                            n1.desPaginaPrincipal
                                          )
                                            ? _c(
                                                "q-collapsible",
                                                {
                                                  staticClass: "gvn-collapse ",
                                                  attrs: {
                                                    group: "grupo2",
                                                    label: n1.nomModulo,
                                                    disable: _vm.appCarregando
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "template",
                                                    { slot: "header" },
                                                    [
                                                      _c("q-item-main", {
                                                        attrs: {
                                                          label: n1.nomModulo,
                                                          id: n1.nomModulo.replace(
                                                            /\s{1,}/g,
                                                            ""
                                                          ),
                                                          name: n1.nomModulo.replace(
                                                            /\s{1,}/g,
                                                            ""
                                                          )
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._l(
                                                    _vm.permissoesArray.filter(
                                                      function(v) {
                                                        return (
                                                          v.codModuloPai ===
                                                          n1.codModulo
                                                        )
                                                      }
                                                    ),
                                                    function(n2) {
                                                      return _c(
                                                        "div",
                                                        { key: n2.f },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "q-ml-lg"
                                                            },
                                                            [
                                                              _vm.verificarLink(
                                                                n2.desPaginaPrincipal
                                                              )
                                                                ? _c(
                                                                    "q-item",
                                                                    {
                                                                      attrs: {
                                                                        to:
                                                                          n2.desPaginaPrincipal
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "q-item-main",
                                                                        {
                                                                          attrs: {
                                                                            color:
                                                                              "white",
                                                                            label:
                                                                              n2.nomModulo,
                                                                            id: n2.nomModulo.replace(
                                                                              /\s{1,}/g,
                                                                              ""
                                                                            ),
                                                                            name: n2.nomModulo.replace(
                                                                              /\s{1,}/g,
                                                                              ""
                                                                            )
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                : _vm._e()
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  )
                                                ],
                                                2
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ])
                                  }
                                )
                              ],
                              2
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  })
                ],
                2
              )
            ],
            1
          )
        ]
      ),
      _c("q-page-container", [_c("router-view")], 1)
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }